import React from 'react'
import { LayoutSubHeader } from 'core/components/layout/LayoutSubHeader'
import { Outlet, useLocation } from 'react-router'
import { ROUTE_PATHS } from 'core/constants/routePath'

export const LayoutApp = () => {
  const isDebug = useLocation().pathname.startsWith(ROUTE_PATHS.IADOCS_DEBUG)

  return (
    <div className="w-full h-full">
      {!isDebug && <LayoutSubHeader />}
      <div
        className={`flex flex-row ${isDebug ? 'h-full' : 'h-[calc(100vh-180px)]'}`}
      >
        <div className="flex-grow overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
